import styled from 'styled-components';
import { COMMUNITY_SIDEBAR_PLUS_BUTTON_RIGHT } from 'styles/sidebarMenuListItemHighlight';

export const StyledList = styled.div`
  position: relative;
`;

export const StyledMenuListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PlusButtonWrapper = styled.div`
  display: flex;
  position: absolute;
  right: ${({ right = COMMUNITY_SIDEBAR_PLUS_BUTTON_RIGHT }) => right};
`;

export const StyledArrow = styled.div`
  display: flex;
  position: absolute;
  right: ${({ right = COMMUNITY_SIDEBAR_PLUS_BUTTON_RIGHT }) => right};
`;
